import 'fast-text-encoding'
import {encode} from 'base64-arraybuffer'

export function encrypt (txt, secret) {
  const encoder = new TextEncoder()
  const toEncrypt = encoder.encode(txt)
  secret = encoder.encode(secret)

  const ret = new Uint8Array(toEncrypt.length)
  let c = 0
  let k = 0

  while (true) {
    const b1 = toEncrypt[c]
    const b2 = secret[k]
    ret[c] = b1 ^ b2
    k++
    if (k >= secret.length) {
      k = k % secret.length
    }
    c++

    if (c === toEncrypt.length) {
      break
    }
  }
  return encode(ret)
}
